import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Access" }
const _hoisted_2 = { style: {"height":"60px","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"height":"60px","line-height":"60px","text-align":"center","margin-left":"14px"} }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'

import { useStore } from '@/store'
import { toDay, secondToString } from '@/utils/date-format'
import { useRoute } from 'vue-router'
import {initEmptyParam} from "@/hooks/useInitParam";
import localCache from "@/utils/cache";
import {ref} from "vue";
import dayjs from "dayjs";
import { ElLoading } from 'element-plus'
import { getPageListData } from '@/service/main/system'


export default /*#__PURE__*/_defineComponent({
  __name: 'Access',
  setup(__props) {

initEmptyParam()
const store = useStore()
const userInfo = store.state.login.userInfo

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return {title: item.realName, value: item.id};
  })
  const userItem = searchFormConfig.formItems.find((item) => item.field === 'empIds')
  userItem!.options = userOptions;
}
getEmp()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  dept!.isDisabled = userInfo.isManager != '1';
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

const route = useRoute()

let queryParam = ref()
if (userInfo.isManager != '1') {
  queryParam.value = {
    empIds: userInfo.id,
    accessTime: [toDay(), toDay()],
    ...route.query
  }
} else {
  queryParam.value = {
    deptId: userInfo.deptId,
    accessTime: [toDay(), toDay()],
    ...route.query
  }
}
store.commit('system/changeQueyryInfo', queryParam.value)

const handleSortChange = (value: any) => {
  console.log(value)
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const resetCb = () => {
  return queryParam.value
}
const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

// 直接调用导出接口
const handleDownBtnClick = async () => {
  console.log('导出按钮被点击')
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '数据下载中...',
    background: 'rgba(0, 0, 0, 0.5)'
  })
  try {
    console.log('开始请求导出接口', store.state.system.queryInfo)
    const res = await getPageListData(
      '/main/fuboAccess/download',
      store.state.system.queryInfo,
      'blob'
    )
    console.log('导出接口返回', res)
    const blob = new Blob([res], { type: 'application/octet-stream' })
    const down = document.createElement('a')
    down.download = '复播访问记录.xlsx'
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
    console.log('导出完成')
  } catch (error) {
    console.error('导出失败', error)
  } finally {
    loadingInstance.close()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "fuboAccess",
      onSortChange: handleSortChange,
      downUrl: "/main/fuboAccess/download",
      downFilename: "复播访问记录.xlsx",
      onDownBtnClick: handleDownBtnClick
    }, {
      material: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          href: scope.row.url,
          type: "primary",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.title), 1)
          ]),
          _: 2
        }, 1032, ["href"])
      ]),
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(scope.row.duration)), 1)
      ]),
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 60,
            src: scope.row.consumerHeadImgUrl
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.consumerNickName), 1)
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})